import { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Add,
  KeyboardArrowDown,
  Menu as MenuIcon,
  MoreVert,
  Print,
  ErrorOutline,
} from "@mui/icons-material";
import { HeaderStyle, StudyCard, studyCardContent } from "./style";
import { NoDataContainer } from "../Common/styles/table";
import { repeatedDataTypes } from "../../utils/question";
import { StudyTabsPhaseData } from "./StudyTab";

type Props = {
  phaseData: StudyTabsPhaseData[];
  type: any;
  openModal: any;
  handleSelectedPhase: any;
  selectedPhase: any;
  handleMenuClick: any;
  canEdit: boolean;
};

const Phases = ({
  phaseData,
  type,
  openModal,
  handleSelectedPhase,
  selectedPhase,
  handleMenuClick,
  canEdit,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const open = Boolean(anchorEl);
  return (
    <>
      <Box sx={{ ...StudyCard, flex: 1 }}>
        <Box sx={{ ...HeaderStyle, py: 2 }}>
          <Typography variant="subtitle1" fontWeight="medium">
            {type?.headerLabel || "Phases"}
          </Typography>

          <Typography variant="subtitle1" fontWeight="medium">
            ({phaseData?.length})
          </Typography>

          {(canEdit || type.val !== "surveyPackage") && (
            <Box sx={{ ml: "auto" }}>
              <Button
                variant="outlined"
                endIcon={<KeyboardArrowDown />}
                onClick={(e) => setAnchorEl(e?.currentTarget)}
              >
                Actions
              </Button>
            </Box>
          )}
        </Box>

        <Divider sx={{ borderColor: "#E5E7EB" }} />

        <Box sx={studyCardContent}>
          {phaseData?.length ? (
            phaseData?.map((item) => (
              <Box
                key={item?.id}
                onClick={() => handleSelectedPhase(item)}
                sx={{ cursor: "pointer" }}
              >
                <Box sx={{ paddingBlock: "4px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      // gap: 2,
                      minHeight: "52px",
                      bgcolor:
                        selectedPhase === item?.id
                          ? "secondary.main"
                          : "transparent",
                      pr: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: "5px",
                        height: "52px",
                        bgcolor:
                          selectedPhase === item?.id
                            ? "primary.main"
                            : "transparent",
                        borderTopRightRadius: "20px",
                        borderBottomRightRadius: "20px",
                      }}
                    />
                    {item?.type ? (
                      <Box paddingY={1.5} ml={2} sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          variant="body1"
                          sx={{
                            color:
                              selectedPhase === item?.id
                                ? "primary.main"
                                : "text.primary",
                            fontWeight:
                              selectedPhase === item?.id ? "medium" : "regular",
                            flex: 1,
                            minWidth: "0px",
                          }}
                          title={item?.name}
                          noWrap
                        >
                          {item?.name}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                            mt: 1,
                          }}
                        >
                          <Chip
                            size="small"
                            sx={{
                              padding: "2px 8px",
                              backgroundColor: "#F3F4F6",
                              fontWeight: "medium",
                              borderRadius: "8px",
                              fontSize: "12px",
                            }}
                            label={`${repeatedDataTypes[item?.type]}`}
                          />
                          {item?.hasForms === false && (
                            <Chip
                              size="small"
                              sx={{
                                padding: "2px 8px",
                                backgroundColor: "#FEF3C7",
                                color: "#92400E",
                                fontWeight: "medium",
                                borderRadius: "8px",
                                fontSize: "12px",
                              }}
                              label="No forms"
                            />
                          )}
                        </Box>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          ml: 2,
                          flex: 1,
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            color:
                              selectedPhase === item?.id
                                ? "primary.main"
                                : "text.primary",
                            fontWeight:
                              selectedPhase === item?.id ? "medium" : "regular",
                            minWidth: "0px",
                          }}
                          title={item?.name}
                          noWrap
                        >
                          {item?.name}
                        </Typography>
                        {type?.val === "surveyPackage" &&
                          item?.hasForms === false && (
                            <Chip
                              size="small"
                              sx={{
                                padding: "2px 8px",
                                backgroundColor: "#FEF3C7",
                                color: "#92400E",
                                fontWeight: "medium",
                                borderRadius: "8px",
                                fontSize: "12px",
                              }}
                              label="No surveys"
                            />
                          )}
                        {type?.val !== "surveyPackage" &&
                          item?.hasForms === false && (
                            <Chip
                              size="small"
                              sx={{
                                padding: "2px 8px",
                                backgroundColor: "#FEF3C7",
                                color: "#92400E",
                                fontWeight: "medium",
                                borderRadius: "8px",
                                fontSize: "12px",
                              }}
                              label="No forms"
                            />
                          )}
                        {type?.val === "surveyPackage" &&
                          item?.hasPhaseIssues && (
                            <Tooltip title="One or more surveys have no forms">
                              <ErrorOutline
                                sx={{
                                  fontSize: 18,
                                  color: "#D97706",
                                  flexShrink: 0,
                                }}
                              />
                            </Tooltip>
                          )}
                      </Box>
                    )}
                    {canEdit && (
                      <IconButton
                        sx={{ ml: "auto" }}
                        onClick={(e) => handleMenuClick(e, item, "phase")}
                      >
                        <MoreVert />
                      </IconButton>
                    )}
                  </Box>
                </Box>
                <Divider sx={{ borderColor: "#E5E7EB", marginInline: 2 }} />
              </Box>
            ))
          ) : (
            <NoDataContainer>
              <Typography variant="body1" color="gray">
                No Data
              </Typography>
            </NoDataContainer>
          )}
        </Box>
      </Box>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {canEdit && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              openModal("phase");
            }}
          >
            <ListItemIcon>
              <Add />
            </ListItemIcon>
            <ListItemText> {type?.buttonLabel || "add"}</ListItemText>
          </MenuItem>
        )}
        {type.val !== "surveyPackage" && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              openModal("print");
            }}
          >
            <ListItemIcon>
              <Print />
            </ListItemIcon>
            <ListItemText> Print Forms</ListItemText>
          </MenuItem>
        )}
        {phaseData?.length > 1 && type.val !== "surveyPackage" && canEdit && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              openModal("rearrangePhases");
            }}
          >
            <ListItemIcon>
              <MenuIcon />
            </ListItemIcon>
            <ListItemText>Rearrange</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default Phases;
